import { IRateConfigSelectorData } from 'types/administration/pricing/underwriterProfileInterfaces/IRateConfigSelector';
import React from 'react';
import { Card } from 'ui-toolkit/components';
import { KeyObjectViewer, LabelValueViewer } from '../shared/LabelValueViewer';
import { RateConfigurationViewer } from './RateConfigurationViewer';
import { screamingSnakeCaseToCapitalize, snakeCaseToRegular } from 'utilities/shared/stringMethods/stringMethods';
import { isPluralArray, pluralize } from 'utilities/shared/stringMethods/pluralize';

interface IRateConfigSelectorViewerProps {
  rates: IRateConfigSelectorData[];
}

export const RateConfigSelectorViewer: React.FC<IRateConfigSelectorViewerProps> = ({ rates }) => (
  <Card
    title={`There ${pluralize(isPluralArray(rates), 'is', 'are')} ${rates.length} rate${pluralize(
      isPluralArray(rates)
    )}`}
  >
    {rates.map((rate) => (
      <Card key={rate.transactionType + rate.rate + Math.random()}>
        <LabelValueViewer label={'Transaction Type'} value={screamingSnakeCaseToCapitalize(rate.transactionType)} />
        {rate.formType && <LabelValueViewer label={'Form Type'} value={snakeCaseToRegular(rate.formType)} />}
        <KeyObjectViewer label={'Rate'}>
          <RateConfigurationViewer rateConfiguration={rate.rate} />
        </KeyObjectViewer>
      </Card>
    ))}
  </Card>
);
